import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stripTags' })
export class StripTagsPipe implements PipeTransform {
    transform(str: string): string {
        return str.replace(/<[^>]*>/g, '');
    }
}
